module.exports = __webpack_public_path__ + "img/banner.cbea72af.jpg";